export function DataTableWidget({ data }: { data: Record<string, unknown> }) {
  const columns = (data.columns ?? []) as string[];
  const rows = (data.rows ?? []) as unknown[][];

  if (columns.length === 0 && rows.length === 0) {
    return <div className="text-gray-500 text-center py-4">No data</div>;
  }

  return (
    <div className="overflow-auto">
      <table className="w-full text-xs">
        <thead>
          <tr className="border-b border-gray-700">
            {columns.map((col, i) => (
              <th
                key={i}
                className="text-left px-2 py-1.5 text-gray-400 font-medium whitespace-nowrap"
              >
                {col}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row, ri) => (
            <tr
              key={ri}
              className="border-b border-gray-800/50 hover:bg-gray-800/30"
            >
              {(Array.isArray(row) ? row : Object.values(row)).map((cell, ci) => (
                <td
                  key={ci}
                  className="px-2 py-1.5 text-gray-300 whitespace-nowrap max-w-[200px] truncate"
                  title={String(cell ?? "")}
                >
                  {String(cell ?? "")}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
      <div className="text-xs text-gray-600 text-center pt-2">
        {rows.length} row{rows.length !== 1 ? "s" : ""}
      </div>
    </div>
  );
}
